import IncidentStatusEnum from 'redpoints-model-js/enumeration/IncidentStatusEnum';
import DetectionLinkProjectionFilter from 'redpoints-model-js/model/filter/DetectionLinkProjectionFilter';
import IncidentInfoCounters from 'redpoints-model-js/model/incident/IncidentInfoCounters';
import IncidentInfoFilters from 'redpoints-model-js/model/incident/IncidentInfoFilters';

import HttpStatus from 'redpoints-connector-common/enumeration/HttpStatus';
import AssetController from 'rpc-restapi-connector/controller/AssetController';
import DetectionLinkProjectionController from 'redpoints-restapi-connector/controller/DetectionLinkProjectionController';
import IncidentInfoController from 'redpoints-restapi-connector/controller/IncidentInfoController';
import IncidentStatusGroupController from 'redpoints-restapi-connector/controller/IncidentStatusGroupController';

import { cast } from 'redpoints-front-common/helpers';

import { getIncidentStatusesFromGroups } from './BoxesSelector/helpers';

export const getDetectionLinkCount = (context, assetId, incidentStatus) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async resolve => {
    let data = 0;

    const filters = new DetectionLinkProjectionFilter();
    filters.assetId = cast.number(assetId, null);
    filters.incidentStatus = incidentStatus
      ? cast.enum(IncidentStatusEnum)(incidentStatus)
      : null;

    const result = await DetectionLinkProjectionController.count(
      context,
      filters
    );
    if (result.status === HttpStatus.OK.value) {
      data = result.response;
    }
    resolve(data);
  });
};

export const getIncidentStatusGroups = async context => {
  const httpResponse = await IncidentStatusGroupController.getIncidentStatusGroups(
    context
  );
  let result = [];
  if (httpResponse.status === HttpStatus.OK.value) {
    result = httpResponse.response;
  }
  return result;
};

export const getIncidentInfoCounters = async (context, queryParams) => {
  const {
    allAssets,
    enforcementStatus,
    critical,
    incidentStatusGroups,
    watch,
  } = queryParams;

  const incidentInfoFilters = Object.assign(new IncidentInfoFilters(), {
    allAssets: allAssets ?? null,
    enforcementStatus: enforcementStatus ?? null,
    critical: critical ?? null,
    incidentStatus: getIncidentStatusesFromGroups(incidentStatusGroups),
    watch: watch ?? null,
  });

  return await IncidentInfoController.countersWithFilters(
    context,
    incidentInfoFilters
  ).then(httpResponse => {
    let result = new IncidentInfoCounters();
    if (httpResponse.status === HttpStatus.OK.value) {
      result = httpResponse.response;
    }
    return result;
  });
};

export const getAssetsNumber = context =>
  AssetController.list(context).then(result =>
    result.status === HttpStatus.OK.value ? result.response.length : NaN
  );
